import { mapGetters, mapState } from 'vuex';
import TranscriptLayer from './TranscriptLayer.vue';

export default {
  components: {
    TranscriptLayer,
  },

  data() {
    return {
      toggleTranscript: false,
    };
  },

  computed: {
    ...mapState('assetEditor', ['workModel']),
    ...mapState('timemachine', {
      tmTrackLayerAudio: (state) => _.map(state.trackLayer.audio, 'data'),
    }),
    ...mapGetters('assetEditor', [
      'showTranscriptForEffectPage',
      'assetTranscription',
    ]),

    thereAreTranscriptToShow() {
      return (
        !_.isEmpty(this.workModel.metadata.transcript) ||
        !_.isEmpty(this.tmTrackLayerAudio) ||
        !_.isEmpty(this.assetTranscription)
      );
    },

    toggleTranscriptLabel() {
      return this.toggleTranscript
        ? app.culture.get('assetEditor.hideTranscript')
        : app.culture.get('assetEditor.showTranscript');
    },
  },

  methods: {
    $_onToggleTranscript() {
      this.toggleTranscript = !this.toggleTranscript;
    },
  },
};
